module.exports = __webpack_public_path__ + "img/balao_balao_3.c33b4631.svg";